/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test your typing speed and accuracy in seconds. Free WPM typing test with 1, 3, and 5-minute modes. No signup.`)
};

const es_typing_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mide tu velocidad de mecanografía y precisión en segundos. Test de mecanografía WPM gratis con modos de 1, 3 y 5 minutos. Sin registro.`)
};

const de_typing_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teste deine Tippgeschwindigkeit und Genauigkeit in Sekunden. Kostenloser WPM-Tipptest mit 1-, 3- und 5-Minuten-Modi. Keine Anmeldung.`)
};

const nl_typing_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test je typsnelheid en nauwkeurigheid in enkele seconden. Gratis WPM-typetest met modi van 1, 3 en 5 minuten. Geen aanmelding.`)
};

const fr_typing_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testez votre vitesse de frappe et votre précision en quelques secondes. Test WPM gratuit avec des modes de 1, 3 et 5 minutes. Sans inscription.`)
};

const it_typing_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testa la tua velocità di digitazione e precisione in pochi secondi. Test WPM gratuito con modalità da 1, 3 e 5 minuti. Nessuna registrazione.`)
};

const pt_br2_typing_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teste sua velocidade e precisão de digitação em segundos. Teste de digitação WPM grátis com modos de 1, 3 e 5 minutos. Sem cadastro.`)
};

const pt_typing_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teste a sua velocidade e precisão de escrita em segundos. Teste de WPM gratuito com modos de 1, 3 e 5 minutos. Sem registo.`)
};

const ja_typing_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数秒でタイピング速度と正確率を測定。1分・3分・5分モードを備えた無料のWPMタイピングテストです。登録不要。`)
};

const zh_typing_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`几秒钟内测试您的打字速度和准确率。免费WPM打字测试，提供1、3和5分钟模式。无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_tool_description", locale)
	if (locale === "en") return en_typing_tool_description(inputs)
	if (locale === "es") return es_typing_tool_description(inputs)
	if (locale === "de") return de_typing_tool_description(inputs)
	if (locale === "nl") return nl_typing_tool_description(inputs)
	if (locale === "fr") return fr_typing_tool_description(inputs)
	if (locale === "it") return it_typing_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_typing_tool_description(inputs)
	if (locale === "pt") return pt_typing_tool_description(inputs)
	if (locale === "ja") return ja_typing_tool_description(inputs)
	return zh_typing_tool_description(inputs)
};